// Sprint 0.3 — Skeleton loader premium (Beach Menu PRD v1.1).
//
// Nessuno spinner. Ogni skeleton replica la forma esatta del contenuto
// finale. Palette sabbia, animazione discreta (tailwind animate-pulse,
// 1.4s ease-in-out) — nessun jitter, nessun lampeggio.

import React from "react";
import { cn } from "@/lib/utils";

/** Primitivo — usato dagli skeleton di dominio. */
export function Shimmer({ className, ...rest }) {
  return (
    <div
      aria-hidden
      className={cn("bg-sand-200 rounded-md animate-pulse", className)}
      {...rest}
    />
  );
}

/** Riga prodotto: foto quadrata + titolo + descrizione + prezzo. */
export function ProductRowSkeleton() {
  return (
    <div className="flex gap-4 py-4 border-b border-sand-200 last:border-b-0">
      <Shimmer className="w-20 h-20 rounded-xl flex-shrink-0" />
      <div className="flex-1 min-w-0 space-y-2 py-1">
        <Shimmer className="h-5 w-3/5" />
        <Shimmer className="h-3 w-4/5" />
        <Shimmer className="h-3 w-2/5" />
      </div>
      <Shimmer className="h-5 w-14 self-start mt-1" />
    </div>
  );
}

/** Pagina menu completa: header sticky + tab bar + lista prodotti. */
export function MenuSkeleton() {
  return (
    <div className="min-h-screen pb-32" data-testid="menu-skeleton">
      <div className="sticky top-0 z-20 bg-sand-100/95 backdrop-blur-xl border-b border-sand-300 px-5 py-4">
        <Shimmer className="h-3 w-20 mb-2" />
        <Shimmer className="h-6 w-48" />
        <Shimmer className="mt-3 h-10 w-full rounded-full" />
        <div className="mt-3 flex gap-2 overflow-hidden">
          {[0, 1, 2, 3].map((i) => (
            <Shimmer key={i} className="h-9 w-24 rounded-full flex-shrink-0" />
          ))}
        </div>
      </div>
      <main className="px-5 mt-6 space-y-4">
        <Shimmer className="h-8 w-48" />
        {[0, 1, 2, 3, 4].map((i) => <ProductRowSkeleton key={i} />)}
      </main>
    </div>
  );
}

/** Pagina stato ordine: header + timeline + riepilogo. */
export function OrderStatusSkeleton() {
  return (
    <div className="min-h-screen px-5 pt-8 pb-10" data-testid="order-status-skeleton">
      <Shimmer className="h-3 w-24" />
      <Shimmer className="mt-3 h-10 w-64" />
      <Shimmer className="mt-2 h-4 w-80 max-w-full" />

      <div className="mt-6 card-elevated p-5">
        <Shimmer className="h-3 w-32 mb-4" />
        <div className="space-y-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-3">
              <Shimmer className="w-6 h-6 rounded-full" />
              <Shimmer className="h-4 flex-1 max-w-[240px]" />
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 card-elevated p-5 space-y-3">
        <Shimmer className="h-3 w-24" />
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-4/5" />
        <div className="pt-2 border-t border-sand-300 flex justify-between">
          <Shimmer className="h-5 w-16" />
          <Shimmer className="h-5 w-20" />
        </div>
      </div>
    </div>
  );
}
